export const SET_ADDRESSES = 'SET_ADDRESSES';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const ADD_BILLING_ADDRESS = 'ADD_BILLING_ADDRESS';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const DELETE_BILLING_ADDRESS = 'DELETE_BILLING_ADDRESS';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const EDIT_BILLING_ADDRESS = 'EDIT_BILLING_ADDRESS';
export const SET_BILLING_ADDRESSES = 'SET_BILLING_ADDRESSES';
export const HAVE_MAIN_ADDRESS = 'HAVE_MAIN_ADDRESS';
